import { render, staticRenderFns } from "./shared-briefcase.html?vue&type=template&id=0c21f832&scoped=true&"
import script from "./shared-briefcase.js?vue&type=script&lang=js&"
export * from "./shared-briefcase.js?vue&type=script&lang=js&"
import style0 from "./shared-briefcase.scss?vue&type=style&index=0&id=0c21f832&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c21f832",
  null
  
)

export default component.exports